<template>
	<svg
		class="bidirectional-half-label-bg"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 639.98 46.99"
		preserveAspectRatio="none"
	>
		<defs>
			<pattern
				id="silk-flag-pattern"
				patternUnits="userSpaceOnUse"
				width="1080"
				height="330"
			>
				<image :href="pathTextures + '/silk-flag-texture-bg.avif'" />
			</pattern>
		</defs>

		<g id="half-left">
			<polygon
				class="half-label-3"
				points="61.61 38.99 93.99 38.99 93.99 40.99 63.61 40.99 61.61 38.99"
			/>
			<polygon
				class="half-label-3"
				points="0 0 46.99 46.99 93.99 46.99 93.99 44.99 47.82 44.99 2.81 0 0 0"
			/>
			<polygon
				class="half-label-2"
				points="21.21 1.41 21.21 1.41 62.79 42.99 62.79 42.99 59.96 42.99 57.13 42.99 53.13 38.99 53.13 38.99 55.96 38.99 53.96 36.99 51.13 36.99 14.12 0 11.3 0 16.97 5.65 48.31 36.99 54.31 42.99 54.31 42.99 51.47 42.99 48.65 42.99 44.65 38.99 44.65 38.99 47.47 38.99 45.47 36.99 42.65 36.99 5.66 0 2.81 0 47.82 44.99 93.99 44.99 93.99 42.99 65.61 42.99 61.61 38.99 93.99 38.99 93.99 36.99 59.61 36.99 22.62 0 19.78 0 21.21 1.41"
			/>
			<polygon
				class="half-label-3"
				points="53.96 36.99 55.96 38.99 55.96 38.99 53.13 38.99 55.13 40.99 57.96 40.99 59.96 42.99 62.79 42.99 19.78 0 16.97 0 53.96 36.99"
			/>
			<polygon
				class="half-label-3"
				points="45.47 36.99 47.47 38.99 47.47 38.99 44.65 38.99 46.65 40.99 49.47 40.99 51.47 42.99 54.31 42.99 48.31 36.99 11.3 0 8.46 0 15.55 7.06 45.47 36.99"
			/>
		</g>
		<g id="half-right">
			<polygon
				class="half-label-3"
				points="578.37 38.99 545.99 38.99 545.99 40.99 576.37 40.99 578.37 38.99"
			/>
			<polygon
				class="half-label-3"
				points="639.98 0 593 46.99 546 46.99 546 44.99 592.17 44.99 637.18 0 639.98 0"
			/>
			<polygon
				class="half-label-2"
				points="618.77 1.41 618.77 1.41 577.19 42.99 577.2 42.99 580.02 42.99 582.86 42.99 586.86 38.99 586.85 38.99 584.03 38.99 586.03 36.99 588.86 36.99 625.87 0 628.68 0 623.01 5.65 591.67 36.99 585.67 42.99 585.68 42.99 588.51 42.99 591.34 42.99 595.34 38.99 595.33 38.99 592.52 38.99 594.52 36.99 597.34 36.99 634.33 0 637.18 0 592.17 44.99 546 44.99 546 42.99 574.38 42.99 578.38 38.99 546 38.99 546 36.99 580.38 36.99 617.37 0 620.21 0 618.77 1.41"
			/>
			<polygon
				class="half-label-3"
				points="586.02 36.99 584.02 38.99 584.03 38.99 586.85 38.99 584.85 40.99 582.02 40.99 580.02 42.99 577.2 42.99 620.21 0 623.01 0 586.02 36.99"
			/>
			<polygon
				class="half-label-3"
				points="594.51 36.99 592.51 38.99 592.52 38.99 595.33 38.99 593.33 40.99 590.51 40.99 588.51 42.99 585.68 42.99 591.68 36.99 628.68 0 631.53 0 624.43 7.06 594.51 36.99"
			/>
		</g>
		<g id="half-bottom">
			<rect
				class="half-label-3"
				x="93.99"
				y="38.99"
				width="452"
				height="2"
			/>
			<rect
				class="half-label-3"
				x="93.99"
				y="44.99"
				width="452"
				height="2"
			/>
			<path
				class="half-label-2"
				d="M93.99,36.99v2h452v-2H93.99ZM93.99,42.99v2h452v-2H93.99Z"
			/>
		</g>
		<g id="half-fill">
			<polygon
				class="half-label-1"
				points="617.36 0 580.37 36.99 59.61 36.99 22.62 0 617.36 0"
			/>
		</g>
		<g class="half-fill-texture">
			<polygon
				class="half-texture-bg-polygon"
				points="617.36 0 580.37 36.99 59.61 36.99 22.62 0 617.36 0"
			/>
		</g>
	</svg>
</template>

<script setup lang="ts">
import { pathTextures } from "@/utils/url";
</script>

<style lang="scss" scoped>
// nove
.half-label-1 {
	fill: #0a7757;
}
.half-label-2 {
	fill: #edd091;
}
.half-label-3 {
	fill: #63451a;
}

.half-texture-bg-polygon {
	fill: url(#silk-flag-pattern);
}

.half-fill-texture {
	mix-blend-mode: color-burn; // NOTE: must be color-burn
}
</style>
